import { useShopper } from "../../../../lib/shopper.js";
import { useTenant } from "../../../../lib/tenant.js";
import { useTerminology } from "../../../../lib/terminology.js";
import type { TemplateAction } from "../../shared/links.js";

export interface HeroContent {
  headline: string;
  body: string;
  actions: TemplateAction[];
  /** The tenant's `branding.bannerUrl` (Storefront → General); "" when it has none. */
  artUrl: string;
}

/** The hero: sign up or log in while signed out, browse the boxes once signed in. */
export function useHeroContent(): HeroContent {
  const { config } = useTenant();
  const { user } = useShopper();
  const { box, item } = useTerminology();
  return {
    headline: "Rip. Collect. Hold.",
    body: `Open digital ${box.plural}, discover rare ${item.plural}, and build your collection. Love what you opened? Get the real thing delivered straight to your door.`,
    actions: user
      ? [{ label: `Browse ${box.plural}`, emphasis: "primary", to: "/boxes" }]
      : [
          { label: "Sign up", emphasis: "primary", to: "/login" },
          { label: "Log in", emphasis: "secondary", to: "/login" },
        ],
    artUrl: config.branding.bannerUrl,
  };
}
